import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FramingBand } from '../components/FramingBand';
import { ProblemSection } from '../components/ProblemSection';
import { PlatformOverview } from '../components/PlatformOverview';
import { OperatingModel } from '../components/OperatingModel';
import { CapabilityDomains } from '../components/CapabilityDomains';
import { HumanOpportunity } from '../components/HumanOpportunity';
import { LifecycleArchitecture } from '../components/LifecycleArchitecture';
import { Solutions } from '../components/Solutions';
import { ProductEcosystem } from '../components/ProductEcosystem';
import { GlobalArchitecture } from '../components/GlobalArchitecture';
import { LeadershipReadiness } from '../components/LeadershipReadiness';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function HumanCapabilityPage() {
  return <>
      <HeroSection data-id="element-2274" data-mp="hmqee383hnr8" />
      <FramingBand data-id="element-2275" data-mp="hn9k8lkh0low" />
      <ProblemSection data-id="element-2276" data-mp="hnrrsecl2mc4" />
      <PlatformOverview data-id="element-2277" data-mp="3g40c3naddg6s" />
      <OperatingModel data-id="element-2278" data-mp="3g4i94m4uvyfr" />
      <CapabilityDomains data-id="element-2279" data-mp="3g5bepjs2whwb" />
      <HumanOpportunity data-id="element-2280" data-mp="3k522rfq80jx5" />
      <LifecycleArchitecture data-id="element-2281" data-mp="3k4k5qgvqi1o6" />
      <Solutions data-id="element-2282" data-mp="3k5lkowfvf8b6" />
      <ProductEcosystem data-id="element-2283" data-mp="3k2zdwz0t0wu0" />
      <GlobalArchitecture data-id="element-2284" data-mp="3p455gtiqae1y" />
      <LeadershipReadiness data-id="element-2285" data-mp="3p3ws70ip16q8" />
      <FAQ data-id="element-2286" data-mp="3p2lu9hbxit71" />
      <FinalCTA data-id="element-2287" data-mp="3p228tqn2lmo9" />
    </>;
}